export type NotificationGroupKey = 'forum' | 'projects' | 'teams' | 'socialOrders' | 'system'

export interface NotificationGroupSettings {
  enabled: boolean
}

export type UserNotificationsMeta = {
  emailEnabled: boolean
  groups: Record<NotificationGroupKey, NotificationGroupSettings>
}

const notificationGroups: NotificationGroupKey[] = ['forum', 'projects', 'teams', 'socialOrders', 'system']

export const getDefaultUserNotificationsMeta = (): UserNotificationsMeta => ({
  emailEnabled: true,
  groups: {
    forum: { enabled: true },
    projects: { enabled: true },
    teams: { enabled: true },
    socialOrders: { enabled: true },
    system: { enabled: true },
  },
})

export const normalizeUserNotificationsMeta = (meta: unknown): UserNotificationsMeta => {
  const root = meta && typeof meta === 'object' ? (meta as Record<string, unknown>) : {}
  const notifications =
    root.notifications && typeof root.notifications === 'object'
      ? (root.notifications as Record<string, unknown>)
      : {}
  const groups =
    notifications.groups && typeof notifications.groups === 'object'
      ? (notifications.groups as Record<string, unknown>)
      : {}

  const normalized = getDefaultUserNotificationsMeta()
  normalized.emailEnabled = notifications.emailEnabled !== false

  notificationGroups.forEach((group) => {
    if (group === 'system') {
      normalized.groups[group] = { enabled: true }
      return
    }

    const groupSettings =
      groups[group] && typeof groups[group] === 'object'
        ? (groups[group] as Record<string, unknown>)
        : {}
    normalized.groups[group] = {
      enabled: groupSettings.enabled !== false,
    }
  })

  return normalized
}

export const buildUserNotificationsMetaPatch = (
  meta: unknown,
  notifications: UserNotificationsMeta,
): Record<string, unknown> => {
  const root = meta && typeof meta === 'object' && !Array.isArray(meta) ? { ...(meta as Record<string, unknown>) } : {}

  return {
    ...root,
    notifications: {
      emailEnabled: notifications.emailEnabled,
      groups: {
        forum: { enabled: notifications.groups.forum.enabled },
        projects: { enabled: notifications.groups.projects.enabled },
        teams: { enabled: notifications.groups.teams.enabled },
        socialOrders: { enabled: notifications.groups.socialOrders.enabled },
        system: { enabled: true },
      },
    },
  }
}
